import * as TYPES from './facility-actiontypes';
import { persistStateToSession } from '../../webstorage';

export const LOCAL_STORAGE_KEY = 'patient:facility';

export const initialState = {
  theme: null,
  facilityName: null,
  facilityPortalName: null,
  facilityShortName: null,
  logo: null,
  facilityId: null,
  resources: {
    faqs: [],
    usefulLinks: null,
    downloadableForms: [],
  },
  defaultCommunicationLanguageId: null,
};

const facilityReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.FACILITY_LOGO_LOADED:
    case TYPES.FACILITY_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      persistStateToSession(LOCAL_STORAGE_KEY, newState);
      break;
    case TYPES.FACILITY_LOADED_FAILURE:
      newState = { ...initialState, ...action.state };
      persistStateToSession(LOCAL_STORAGE_KEY, newState);
      break;
    case TYPES.SINGLE_DOWNLOAD_LOADED:
    case TYPES.FACILITY_FAQ_LOADED_SUCCESS:
    case TYPES.USEFUL_LINKS_LOADED_SUCCESS: {
      const resources = { ...state.resources, ...action.state };
      newState = {
        ...state,
        resources };
      persistStateToSession(LOCAL_STORAGE_KEY, newState);
      break;
    }
    case TYPES.DOWNLOADABLE_FORMS_LOADED_SUCCESS: {
      const downloadableForms = Object.assign([],
        state.resources.downloadableForms,
        action.state.downloadableForms);
      newState = {
        ...state,
        resources: {
          ...state.resources,
          downloadableForms,
        } };
      persistStateToSession(LOCAL_STORAGE_KEY, newState);
      break;
    }
    case TYPES.FACILITY_FAQ_LOADED_FAILURE:
    case TYPES.DOWNLOADABLE_FORMS_LOADED_FAILURE:
    case TYPES.USEFUL_LINKS_LOADED_FAILURE:
      newState = { ...state, ...action.state };
      persistStateToSession(LOCAL_STORAGE_KEY, newState);
      break;
    default:
      newState = state;
  }

  return newState;
};

export default facilityReducer;
